import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
import scatterChart from '@/components/bigDataChart/scatterChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterScatterChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '640px'
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    reportType: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dataSource: {},
      reportType: ''
    };
  },
  components: {
    scatterChart: scatterChart
  },
  mounted: function mounted() {
    var _this = this;

    this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
      }
    });
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(reportType) {
      var _this2 = this;

      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.$refs.chart3) return;
      var that = this;
      that.reportType = reportType;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: window.sessionStorage.getItem('siteId') || '',
        type: '3',
        dataType: reportType,
        column: 'data_time',
        order: 'asc'
      };
      var options = [];
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          var dataList = [];
          var itemStyle = {
            opacity: 0.8,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(255, 255, 255, 0.5)'
          };
          that.dataSource = JSON.parse(JSON.stringify(res.result));
          res.result.records.forEach(function (item, index) {
            var items = [];

            for (var key in item.factor) {
              items.push(item.factor[key].value);
            } // console.log(item.dataTime, item.dataTime.slice(item.dataTime.length - 2, item.dataTime.length))


            dataList.push([parseInt(item.dataTime.slice(item.dataTime.length - 2, item.dataTime.length))].concat(items));
          });
          var schemaData = [];
          res.result.query.factors.forEach(function (item, index) {
            options.push({
              label: item.alias || item.title,
              value: item.code,
              categoryName: item.categoryName
            });
            schemaData.push({
              index: index + 1,
              text: item.alias || item.title
            });
          });
          var data = {
            schemaData: schemaData,
            seriesData: [{
              name: '',
              type: 'scatter',
              itemStyle: itemStyle,
              data: dataList
            }]
          };

          if (state) {
            _this2.$nextTick(function () {
              that.$parent.$parent.$refs.colControl.firstState = true;
            });
          }

          that.$emit('factorOption', options); // console.log('datas', data, reportType, res.result.query.factors)
          // that.$refs.chart3.initScatterChart(data, reportType, res.result.query.factors)
        }
      });
    },
    changeChartInit: function changeChartInit(data, factors) {
      console.log('(data, this.reportType, factors)', data, this.reportType, factors);
      this.$refs.chart3.initScatterChart(data, this.reportType, factors);
    }
  },
  watch: {
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.querySewageQuotaList(this.reportType);
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(this.reportType, false);
    }
  }
};